import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinvelhe() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Velhe',
        heading: 'Urbania on rent in pune: Urbania On Rent in Velhe',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Urbania On Rent in Velhe for corporate groups, families, tourists, and event travelers planning trips to and from Velhe. Our well‑maintained Force Urbania fleet provides spacious seating, air‑conditioned comfort, and smooth performance, making it ideal for long‑distance travel, weekend getaways, corporate outings, airport transfers, weddings, sightseeing, and outstation journeys from Pune to Velhe. With professional chauffeurs, flexible one‑way and round‑trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe and stress‑free travel experience. Backed by 24/7 booking support, punctual service, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for premium Urbania hire in Velhe.',

        top: 'Top Places to Visit in Velhe with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Velhe Fort",
    "description": "Velhe Fort is a historic hill fort located in the Western Ghats near Pune. It offers panoramic views of the surrounding Sahyadri ranges, lush valleys, and nearby villages. The fort holds historical significance from the Maratha era and attracts trekkers, history enthusiasts, and photographers. The trek to the fort passes through dense forests, rocky paths, and scenic viewpoints, making it an adventurous and culturally enriching experience."
  },
  {
    "title": "Ramlingeshwar Temple",
    "description": "Ramlingeshwar Temple is an ancient temple dedicated to Lord Shiva, situated in Velhe village. Surrounded by greenery and hills, it provides a peaceful spiritual ambiance. The temple is especially vibrant during Mahashivratri, attracting devotees from nearby towns. The combination of serene surroundings and cultural significance makes it an important landmark in Velhe."
  },
  {
    "title": "Velhe Waterfalls",
    "description": "Velhe and its surrounding areas feature several seasonal waterfalls that become spectacular during the monsoon. These cascades, nestled amidst dense forests and rocky terrain, offer refreshing sights, picnic spots, and opportunities for nature photography. The sound of flowing water and the lush greenery make visiting waterfalls a rejuvenating experience for families and adventure seekers alike."
  },
  {
    "title": "Trekking Trails Around Velhe",
    "description": "Velhe is surrounded by scenic trekking routes that pass through the Western Ghats’ dense forests, open grasslands, and rugged hills. Trekkers can explore small forts, old watchtowers, and hidden water bodies along these trails. The treks are suitable for both beginners and experienced hikers, offering breathtaking landscapes, birdwatching, and a sense of adventure."
  },
  {
    "title": "Local Villages and Rural Life",
    "description": "The villages around Velhe provide an authentic glimpse into rural Maharashtrian life. Visitors can observe traditional farming practices, small temples, village fairs, and local customs. The open fields, terraced farms, and friendly locals offer an immersive experience of simplicity and natural beauty away from urban hustle."
  },
  {
    "title": "Koyna Wildlife Corridor Viewpoints",
    "description": "Near Velhe, certain vantage points offer glimpses of the Koyna Wildlife Corridor. Visitors may spot wildlife like deer, monkeys, and a variety of birds. These viewpoints are ideal for photography, wildlife observation, and enjoying quiet moments in nature while surrounded by the lush Western Ghats landscape."
  },
  {
    "title": "Velhe Lake",
    "description": "Velhe Lake is a small reservoir near the village, attracting locals and visitors for leisure walks, photography, and picnics. The calm waters reflect the surrounding hills and greenery, providing a serene environment for relaxation. During monsoon, the lake swells and enhances the scenic beauty of Velhe."
  },
  {
    "title": "Shree Vitthal Temple, Velhe",
    "description": "Dedicated to Lord Vitthal, this temple is a local spiritual hub. Devotees visit regularly for prayers, festivals, and rituals. The temple’s peaceful ambiance combined with surrounding natural beauty makes it a favored spot for locals and travelers seeking spiritual tranquility."
  },
  {
    "title": "Monsoon Valley Walks",
    "description": "Velhe’s valleys and forested paths become especially beautiful during the monsoon, with flowing streams, fresh greenery, and mist-covered hills. Walking through these paths offers a rejuvenating experience and opportunities for photography, nature observation, and quiet reflection."
  },
  {
    "title": "Historical Maratha Watchpoints",
    "description": "Around Velhe, small historical watchpoints and ruins from the Maratha era can be found. These elevated points offer excellent views of the surrounding terrain and provide insight into the military strategies of the past. They are interesting for history enthusiasts and adventurous travelers exploring offbeat sites in the Western Ghats."
  }
],



"services": [
    {
      "name": "Urbania on Rent in Velhe",
      "description": "Urbania on Rent in Velhe provides fully air-conditioned Urbania vehicles for city travel, family outings, corporate trips, and leisure journeys. Each vehicle is well-maintained and driven by professional chauffeurs to ensure safe, comfortable, and convenient travel."
    },
    {
      "name": "Velhe Urbania Bus Hire",
      "description": "Velhe Urbania Bus Hire offers spacious air-conditioned buses for group tours, corporate events, school trips, and social gatherings. Comfortable seating and experienced drivers make every journey reliable, safe, and enjoyable."
    },
    {
      "name": "Urbania Rental Service Velhe",
      "description": "Urbania Rental Service Velhe delivers premium Urbania vehicles suitable for family trips, sightseeing, corporate travel, and leisure outings. Professional chauffeurs ensure convenient, safe, and dependable transportation at all times."
    },
    {
      "name": "Urbania AC Bus on Rent Velhe",
      "description": "Urbania AC Bus on Rent Velhe provides fully air-conditioned buses for long-distance travel, group tours, and corporate outings. Spacious interiors and trained chauffeurs ensure a smooth and comfortable journey."
    },
    {
      "name": "Corporate Urbania Hire Velhe",
      "description": "Corporate Urbania Hire Velhe offers professional transportation services for office trips, employee commutes, and corporate events. Punctual service and experienced chauffeurs ensure smooth, reliable, and professional travel solutions."
    },
    {
      "name": "Urbania for Outstation Velhe",
      "description": "Urbania for Outstation Velhe provides safe and comfortable long-distance travel with air-conditioned vehicles. Experienced drivers make trips to nearby cities, tourist destinations, and corporate locations convenient and enjoyable."
    },
    {
      "name": "Urbania Airport Transfer Velhe",
      "description": "Urbania Airport Transfer Velhe ensures timely pickups and drops for domestic and international airports. Spacious vehicles and professional chauffeurs provide convenient, safe, and stress-free airport transportation."
    },
    {
      "name": "Luxury Urbania Velhe",
      "description": "Luxury Urbania Velhe offers high-end air-conditioned Urbania vehicles with plush interiors for VIP travel, weddings, and executive trips. Chauffeurs ensure a premium, stylish, and comfortable travel experience."
    },
    {
      "name": "Affordable Urbania Hire Velhe",
      "description": "Affordable Urbania Hire Velhe provides budget-friendly Urbania rental services without compromising on comfort or reliability. Ideal for families, groups, and corporate clients seeking value-for-money travel."
    },
    {
      "name": "Chauffeur Driven Urbania Velhe",
      "description": "Chauffeur Driven Urbania Velhe ensures stress-free travel with trained, verified chauffeurs. Fully air-conditioned vehicles provide smooth, safe, and comfortable journeys for all passengers."
    },
    {
      "name": "Urbania for Wedding Events Velhe",
      "description": "Urbania for Wedding Events Velhe offers elegant air-conditioned vehicles for weddings, guest transport, and family travel. Professional chauffeurs ensure timely, stylish, and hassle-free transportation."
    },
    {
      "name": "Urbania for Office Trips Velhe",
      "description": "Urbania for Office Trips Velhe delivers reliable and comfortable transportation for daily office commutes, team outings, and corporate events. Focused on convenience and punctuality for corporate travel needs."
    },
    {
      "name": "Best Urbania Rental Velhe",
      "description": "Best Urbania Rental Velhe provides top-rated Urbania rental services known for reliability, vehicle quality, and customer satisfaction. Suitable for corporate travel, family trips, and group outings requiring premium transportation."
    },
    {
      "name": "Urbania Group Travel Velhe",
      "description": "Urbania Group Travel Velhe offers organized and comfortable transportation for group tours, corporate outings, and social events. Fully air-conditioned buses with professional chauffeurs ensure safe, convenient, and enjoyable group travel."
    },
    {
      "name": "Reliable Urbania Hire Velhe",
      "description": "Reliable Urbania Hire Velhe provides trustworthy, punctual, and safe Urbania rental services. Air-conditioned vehicles with trained chauffeurs ensure convenient, comfortable, and dependable travel for all passengers."
    }
  ],
  "tableData": [
    ["Urbania on Rent in Velhe", "Velhe Urbania Bus Hire"],
    ["Urbania Rental Service Velhe", "Urbania AC Bus on Rent Velhe"],
    ["Corporate Urbania Hire Velhe", "Urbania for Outstation Velhe"],
    ["Urbania Airport Transfer Velhe", "Luxury Urbania Velhe"],
    ["Affordable Urbania Hire Velhe", "Chauffeur Driven Urbania Velhe"],
    ["Urbania for Wedding Events Velhe", "Urbania for Office Trips Velhe"],
    ["Best Urbania Rental Velhe", "Urbania Group Travel Velhe"],
    ["Reliable Urbania Hire Velhe", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania On Rent in Velhe",
        "WhyChoosedescription": "Urbania On Rent in Velhe is ideal for group travel, corporate trips, family outings, wedding guest transport, and outstation journeys, offering comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Luxury and Spacious Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania On Rent in Velhe provides well-maintained Force Urbania vehicles with modern interiors, air-conditioning, and ample legroom for a smooth and comfortable travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania On Rent in Velhe comes with skilled and courteous drivers familiar with Velhe routes, Pune highways, and nearby areas, ensuring safe and punctual travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Urbania On Rent in Velhe for competitive rates with no hidden charges, making group, corporate, and family travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania On Rent in Velhe provides round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania On Rent in Velhe is available for hourly rentals, full-day bookings, corporate trips, wedding transportation, airport transfers, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles provided for Urbania On Rent in Velhe are regularly cleaned, sanitized, and serviced to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania On Rent in Velhe guarantees on-time pickups and dependable service for stress-free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania On Rent in Velhe available for local and outstation travel?',
        answer: 'Yes, Urbania On Rent in Velhe can be booked for city travel, corporate trips, family outings, and long-distance journeys.',
    },
    {
        question: 'How can I book Urbania On Rent in Velhe?',
        answer: 'You can book Urbania On Rent in Velhe via phone, WhatsApp, or online for fast and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania On Rent in Velhe?',
        answer: 'Urbania On Rent in Velhe offers spacious seating, professional drivers, clean vehicles, and transparent pricing for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Urbania On Rent in Velhe are trained, licensed, and experienced in providing safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Urbania On Rent in Velhe allows flexible pickup and drop locations across Velhe, Pune, and nearby areas.',
    },
    {
        question: 'Is Urbania On Rent in Velhe available 24x7?',
        answer: 'Yes, Urbania On Rent in Velhe operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all Urbania vehicles are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Urbania On Rent in Velhe accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Urbania be used for corporate, family, and outstation trips?',
        answer: 'Yes, Urbania On Rent in Velhe is ideal for corporate travel, family outings, airport transfers, and group or outstation journeys.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sanjay Kadam',
        feedback: 'Urbania On Rent in Velhe made our group trip very comfortable and enjoyable. Spacious, clean, and reliable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya More',
        feedback: 'We hired Urbania On Rent in Velhe for a corporate outing. Excellent service and professional driver.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Ashok Patil',
        feedback: 'Urbania On Rent in Velhe provided smooth and hassle-free travel for our family trip. Highly recommended.',
        rating: 5,
    },
];






















































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Velhe",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-velhe.jpg",
  "description": "Urbania On Rent in Velhe offers AC and non-AC Urbania buses for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation in Velhe and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-on-rent-velhe"
  }
};




    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania On Rent in Velhe | AC & Luxury Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Urbania On Rent in Velhe for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation in Velhe Pune."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Velhe, Velhe Urbania Bus Hire, Urbania Rental Service Velhe, Urbania AC Bus on Rent Velhe, Corporate Urbania Hire Velhe, Urbania for Outstation Velhe, Urbania Airport Transfer Velhe, Luxury Urbania Velhe, Affordable Urbania Hire Velhe, Chauffeur Driven Urbania Velhe, Urbania for Wedding Events Velhe, Urbania for Office Trips Velhe, Best Urbania Rental Velhe, Urbania Group Travel Velhe, Reliable Urbania Hire Velhe"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/103.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinvelhe;